// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import apolloClient from 'apolloClient';

import IIS_APP_POOL_RESELLER_SETTINGS_PAGE from 'queries/IisAppPoolResellerSettingsPage.graphql';

export const iisAppPoolResellerSettingsRoute = {
    path: 'iis-app-pool/settings',
    componentLoader: () => import(
        /* webpackChunkName: "components/pages/IisAppPoolPage/IisAppPoolResellerSettingsPage" */'components/pages/IisAppPoolPage/IisAppPoolResellerSettingsPage'),
    loader: async () => {
        const { data } = await apolloClient.query({
            query: IIS_APP_POOL_RESELLER_SETTINGS_PAGE,
        });

        if (!data.iisManager.appPoolSupported) {
            throw new Response('Not Found', { status: 404 });
        }

        return data;
    },
    handle: {
        helpContext: 'iisapppool',
        crumb: () => ({
            title: Locale.getSection('components.routes').lmsg('iisAppPoolResellerSettings'),
            href: '/cp/reseller-tools/iis-app-pool/settings',
        }),
    },
};
